// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Patrons_header-wrapper__2cjDi","ubc":"Patrons_ubc__3VjDT","uot":"Patrons_uot__abDZv"};